import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import { changeContextMode } from '../../actions/MenuActions';
import { changeAcoordionWidth } from '../../actions/AccordionActions';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import modeType from '../../constants/ModeConstants';
import mouseUtils from '../../components/utils/MouseUtils';
import zoomUtils from '../../components/utils/ZoomUtils';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import helpUtils from '../utils/HelpUtils';
import appParameters from '../utils/AppParameters';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import platformDetection from '../utils/PlatformDetection';
import configuration from '../../constants/Configuration';
import locales from "../../locales/LocalesManager";

const SaveButtonContent = React.createClass({
    getInitialState () {
        return {
            isSaveButtonOver: false,
            isHelpButtonOver: false
        };
    },
    onSaveMouseIn () {
        hoverManager.show(this.refs.holder, 'saveButton', 'left');

        this.setState({
            isSaveButtonOver: true
        });
    },
    onSaveMouseOut () {
        hoverManager.hide();

        this.setState({
            isSaveButtonOver: false
        });
    },
    onSaveClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        zoomUtils.closeZoom();

        if (document.activeElement)
            document.activeElement.blur();

        if (playController.isAudioEditorMode())
            this.props.dispatch(changeAcoordionWidth(properties.BROWSER_WIDTH));

        if (appParameters.context != modeType.AUDIO_TOOL)
            this.props.dispatch(updateCurrentSlide());

        this.props.dispatch(changeContextMode(modeType.SAVE_CONTEXT));
    },
    onHelpMouseIn() {
        hoverManager.show(this.refs.help, 'helpButton', 'left');

        this.setState({
            isHelpButtonOver: true
        });
    },
    onHelpMouseOut() {
        hoverManager.hide();

        this.setState({
            isHelpButtonOver: false
        });
    },
    onHelpClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var url;

        if (appParameters.locale.indexOf('nb_NO') != -1 || appParameters.locale.indexOf('nn_NO') != -1)
            url = 'https://web.creaza.com/no/help/cartoonist';
        else
        if (appParameters.locale.indexOf('sv_SE') != -1)
            url = 'https://web.creaza.com/se/help/skapatecknadserie';
        else
            url = 'https://web.creaza.com/en/help/create-a-cartoon';


        window.open(url, '_blank');
    },
    render () {
        if (!audioToolUtils.isAudioTool())
            helpUtils.checkHelpInfo();

        var isIOS = platformDetection.isIOS();
        var width = properties.MAIN_MENU_WIDTH;
        var height = isIOS ? 40 : properties.CLIPART_BUTTON_HEIGHT;
        var iconColor;

        if (this.state.isSaveButtonOver == true)
            iconColor = '#c0c0c0';
        else
            iconColor = 'white';

        const holderStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: width,
            height: height,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none'
        };

        const saveButtonStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: width,
            height: height,
            background: properties.INSERT_MENU_BUTTON_COLOR,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            cursor: 'pointer',
            borderStyle: 'none'
        };

        var saveIconStyle = {
            position: 'absolute',
            top: isIOS ? 12 : 7,
            left: 12,
            color: iconColor,
            fontSize: 16
        };

        var preloaderVisible = 'none';

        if (this.props.showSavePreloader == true || configuration.LOAD_LOCAL)
            preloaderVisible = 'block';

        const preloaderHolderStyle = {
            position: 'absolute',
            left: 0,
            top: isIOS ? 75 : 70,
            display: preloaderVisible
        };

        var preloaderStyle = {
            position: 'absolute',
            top: 6,
            left: 2,
            color: 'black'
        };

        var src;

        // if (this.state.isHelpButtonOver == true)
            src = appParameters.RESOURCES_LOCATION() + 'assets/mainMenu_help.svg';
        // else
        //     src = appParameters.RESOURCES_LOCATION() + 'assets/tutorial.svg';

        var linkStyle = {
            position: 'absolute',
            top: isIOS ? 47 : 37,
            width: properties.MAIN_MENU_WIDTH,
            height: 20,
            left: 0,
            cursor: 'pointer'
        };

        var helpStyle = {
            position: 'relative',
            top: 0,
            width: properties.MAIN_MENU_WIDTH,
            height: 20,
            left: 0
        };

        var preloaderClass = 'fa fa-spinner fa-pulse fa-2x';

        if (audioToolUtils.isAudioTool() || platformDetection.isIOSApp())
            helpStyle.display = 'none';

        return (
            <div style={holderStyle}>
                <button ref='holder' aria-label={locales.getCaption('SaveMenuTitle', 'save')} style={saveButtonStyle} onTouchEnd={this.onSaveClick} onClick={this.onSaveClick} onMouseOver={this.onSaveMouseIn} onMouseOut={this.onSaveMouseOut}>
                    <i style={saveIconStyle} className="fa fa-floppy-o"></i>
                </button>
                <a id="helpButton" ref='help' aria-label={locales.getCaption('helpButton', 'hover')} style={linkStyle} href='' onTouchEnd={this.onHelpClick} onClick={this.onHelpClick} onMouseOver={this.onHelpMouseIn} onMouseOut={this.onHelpMouseOut}>
                    <img alt={locales.getCaption('helpButton', 'hover')} aria-hidden='true' style={helpStyle} src={src}/>
                </a>
                <div style={preloaderHolderStyle}>
                    <i style={preloaderStyle} className={preloaderClass} />
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showSavePreloader = state.menu.showSavePreloader;
    const contextMode = state.menu.contextMode;

    return {
        showSavePreloader,
        contextMode
    };
}

export const SaveButton = connect(mapStateToProps)(SaveButtonContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/SaveButton.js
 **/